import React from 'react';
import { IconContainer } from './IconContainer';

const PackagePermissionsAuditIcon = (props) => {
    return (
        <IconContainer ariaLabel="package-audit" {...props}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M-15 -24H-24V-22H-15V-24ZM14.5 13C14.5 14.3807 13.3807 15.5 12 15.5C11.6924 15.5 11.3978 15.4445 11.1257 15.3429L14.0935 11.6331C14.3506 12.0259 14.5 12.4955 14.5 13ZM12.9346 10.6806L9.94257 14.4206C9.66349 14.0172 9.5 13.5277 9.5 13C9.5 11.6193 10.6193 10.5 12 10.5C12.3304 10.5 12.6459 10.5641 12.9346 10.6806ZM16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13ZM21 5H12.4142L10.4142 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V6C22 5.44772 21.5523 5 21 5ZM4 19V7H20V19H4Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { PackagePermissionsAuditIcon };